<template>
	<div
		v-if="ready"
		class="container"
	>

		<div class="row center">
			<div class="col-lg-10 col-md-12">
				<h1 class="main-content-title">
					{{ pageTitle }}
				</h1>
			</div>
		</div>

		<div class="row center">
			<div class="col-lg-10 col-md-12">
				<div class="box">
					<div class="box-head with-line">
						<el-breadcrumb separator-class="el-icon-arrow-right">
							<el-breadcrumb-item :to="{ path: '/help' }">
								{{ translations.labels.helpSupport }}
							</el-breadcrumb-item>
							<el-breadcrumb-item>
								{{ pageTitle }}
							</el-breadcrumb-item>
						</el-breadcrumb>
					</div>
					<div class="box-body">
						<div class="row">
							<div class="col-lg-12">

								<el-collapse v-model="activeTab" accordion>
									<el-collapse-item
										v-for="(item, index) in qa"
										:key="index"
										:title="item.question"
										:name="index"
									>
										<span v-html="filterText(item.answer)"></span>
									</el-collapse-item>
								</el-collapse>

							</div>
						</div>
					</div>
				</div>
			</div>
		</div>

	</div>
</template>

<script>
import { _getHelp } from '@/services/api/help'

export default {
	name: 'HelpCategory',
	metaInfo () {
		return {
			title: this.pageTitle
		}
	},
	data () {
		return {
			api: process.env.VUE_APP_API,
			activeTab: [],
			currentPage: null,
			pageTitle: null,
			qa: []
		}
	},
	created () {
		this.findCategory()
	},
	methods: {

		ajaxLoadData () {
			_getHelp(this.user.settings.language)
				.then(response => {
					this.qa = response[this.currentPage]
					this.removeLoader()
				})
		},

		findCategory () {
			if (this.$route.params.category === 'billing-invoices') {
				this.currentPage = 'billing'
				this.pageTitle = 'Billing & Invoice'
			} else if (this.$route.params.category === 'knowledge-base') {
				this.currentPage = 'knowledgeBase'
				this.pageTitle = 'Knowledge base'
			} else if (this.$route.params.category === 'general') {
				this.currentPage = 'general'
				this.pageTitle = 'General'
			} else if (this.$route.params.category === 'privacy') {
				this.currentPage = 'privacy'
				this.pageTitle = 'Privacy & Security'
			} else {
				this.redirectTo('/help')
				return false
			}
			this.ajaxLoadData()
		},
		filterText (text) {
			const email_regex = /([a-zA-Z0-9._-]+@[a-zA-Z0-9._-]+\.[a-zA-Z0-9._-]+)/gi
			return text.replace(email_regex,'<a href="mailto:$1">$1</a>')
		}
		
	}

}
</script>
